module.exports = __webpack_public_path__ + "img/pk1.48b3d568.svg";